import React from "react";
import ActionsMenu from "./ActionsMenu";
import { MonitorMeta } from "./types";

interface ToolbarProps {
  meta: MonitorMeta;
  selectedCount: number;
  busy: boolean;
  onMassSignSelected: () => void;
  onMassSignAll: () => void;
  onUnlockSelected: () => void;
}

export default function Toolbar(props: ToolbarProps) {
  const {
    meta,
    selectedCount,
    busy,
    onMassSignSelected,
    onMassSignAll,
    onUnlockSelected
  } = props;

  return (
    <div className="monitor-react-toolbar">
      <div className="monitor-react-toolbar-row">
        <div className="monitor-react-toolbar-left" />
        <div className="monitor-react-toolbar-right">
          <ActionsMenu
            canMassSign={meta.can_mass_sign_stable_visits}
            canUnlock={meta.can_override_locks}
            hasSelection={selectedCount > 0}
            busy={busy}
            onMassSignSelected={onMassSignSelected}
            onMassSignAll={onMassSignAll}
            onUnlockSelected={onUnlockSelected}
          />
        </div>
      </div>
    </div>
  );
}
